import { render, staticRenderFns } from "./PushNotificationsListFilter.vue?vue&type=template&id=901dd0bc&"
import script from "./PushNotificationsListFilter.vue?vue&type=script&lang=js&"
export * from "./PushNotificationsListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports